import { create } from 'zustand';

/**
 * Prompt 14 Phase 3: Unified Workbench Context
 * 하나의 TestSession을 중심으로 모든 화면이 공유하는 선택 Context.
 * Project 변경 / Logout 시 resetStores를 통해 초기화된다.
 */
export interface WorkbenchContextState {
  selectedSessionId: string | null;
  selectedRunId: string | null;
  selectedMessageId: string | null;
  selectedEvidenceId: string | null;
  selectedVehicleId: string | null;
  selectedTimestamp: string | null;

  selectSession: (sessionId: string | null) => void;
  selectRun: (runId: string | null) => void;
  selectMessage: (messageId: string | null, timestamp?: string | null) => void;
  selectEvidence: (evidenceId: string | null) => void;
  selectVehicle: (vehicleId: string | null) => void;
  selectTimestamp: (timestamp: string | null) => void;
  resetAll: () => void;
}

const initialState = {
  selectedSessionId: null,
  selectedRunId: null,
  selectedMessageId: null,
  selectedEvidenceId: null,
  selectedVehicleId: null,
  selectedTimestamp: null,
};

export const useWorkbenchContextStore = create<WorkbenchContextState>((set) => ({
  ...initialState,

  selectSession: (selectedSessionId) => set({ selectedSessionId }),
  selectRun: (selectedRunId) => set({ selectedRunId }),
  selectMessage: (selectedMessageId, selectedTimestamp) =>
    set((state) => ({
      selectedMessageId,
      selectedTimestamp: selectedTimestamp !== undefined ? selectedTimestamp : state.selectedTimestamp,
    })),
  selectEvidence: (selectedEvidenceId) => set({ selectedEvidenceId }),
  selectVehicle: (selectedVehicleId) => set({ selectedVehicleId }),
  selectTimestamp: (selectedTimestamp) => set({ selectedTimestamp }),
  resetAll: () => set({ ...initialState }),
}));

export default useWorkbenchContextStore;
